import React, { useContext } from 'react';
import styles from './BurgerMenuButton.module.css';
import { ReactComponent as BurgerExpand } from '../assets/burger.svg';
import { ReactComponent as BurgerCollapse } from '../assets/burger-collapsed.svg';
import { ThemeContext } from '../contexts/ThemeContext';

const BurgerMenuButton = ({showBurgerMenu, toggleBurgerMenu}) => {
  const { dark } = useContext(ThemeContext);

  return (
    <div className={styles.burgerMenuContainer}>
      {showBurgerMenu ? (
          <BurgerCollapse
            className={dark ? styles.burgerIconDark : styles.burgerIconLight}
            onClick={toggleBurgerMenu} />
      ) : (
          <BurgerExpand
            className={dark ? styles.burgerIconDark : styles.burgerIconLight}
            onClick={toggleBurgerMenu} />
        )}
    </div>
  );
}

export default BurgerMenuButton;